import React from 'react';
import { useAppStore } from '../../../../store/useAppStore';
import AssetPicker from '../../../Assets/AssetPicker';

export const VideoForm = ({ component, onUpdate }) => {
  const { appName } = useAppStore();

  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      {/* Asset Picker for selecting from library or uploading */}
      {appName && (
        <AssetPicker
          appId={appName}
          value={specificAttrs.src || ''}
          onChange={(url) => handleChange('src', url)}
          label="Video Asset"
          fileType="video"
          placeholder="Select a video from library..."
          showPreview={true}
        />
      )}
      
      {/* Manual URL Input (fallback) */}
      <div>
        <label style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563', display: 'block', marginBottom: '4px' }}>
          Or Enter Video URL Manually
        </label>
        <input
          type="text"
          value={specificAttrs.src || ''}
          onChange={(e) => handleChange('src', e.target.value)}
          placeholder="https://example.com/video.mp4"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.controls !== false}
            onChange={(e) => handleChange('controls', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Show Controls
          </span>
        </label>
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.autoplay || false}
            onChange={(e) => handleChange('autoplay', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Autoplay
          </span>
        </label>
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.loop || false}
            onChange={(e) => handleChange('loop', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Loop
          </span>
        </label>
      </div>
      
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.muted || false}
            onChange={(e) => handleChange('muted', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Muted
          </span>
        </label>
      </div>
    </div>
  );
};









